import { Component, HostListener, Output, EventEmitter, inject } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef, GridReadyEvent } from 'ag-grid-community';
import { PeripheralsService } from '../services/peripherals-service/peripherals.service';
import { get } from 'lodash'; // for copy data cell value
import { CommonModule } from '@angular/common'; // for bind ng style
import { ButtonCellRendererComponent } from '../shared/components/button-cell-renderer/button-cell-renderer.component';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ConfirmDeletePeripheralComponent } from '../Dialogs/confirm-delete-peripheral/confirm-delete-peripheral.component';
import { ToastrService } from 'ngx-toastr';
import { AgGridCopyCellTooltipDirective } from '../shared/ag-grid/ag-grid-copy-cell-tooltip.directive';
import { formatUtcDateTimeCell } from '../shared/ag-grid/ag-grid-date-column.util';

const PERIPHERALS_INFO_TOOLTIP =
  'Peripheral information comes from the Installer App and reflects the state ' +
  'recorded during the last physical installation. Check Device Health for current information.';

@Component({
  selector: 'app-peripherals-management',
  standalone: true,
  imports: [
    AgGridAngular,
    CommonModule,
    ButtonCellRendererComponent,
    MatDialogModule,
    MatIconModule,
    MatTooltipModule,
    AgGridCopyCellTooltipDirective,
  ],
  templateUrl: './peripherals-management.component.html',
  styleUrl: './peripherals-management.component.scss',
})
export class PeripheralsManagementComponent {
  readonly peripheralInfoTooltip = PERIPHERALS_INFO_TOOLTIP;

  rowData: any;
  gridApi: any;
  page: number = 0;
  size: number = 25;
  totalElements: any;
  sortFlag: boolean = false;
  deviceId: any;
  periIds: number[] = []
  loadComp: boolean = true;
  @Output() loaded = new EventEmitter<void>();
  constructor(private peripheralsService: PeripheralsService) { }
  private dialog = inject(MatDialog);
  private toastr = inject(ToastrService);

  defaultColDef: ColDef = {
    sortable: true,
    sortingOrder: ['asc', 'desc'],
    sort: 'asc',
    floatingFilter: false,
  };

  columnDefs: ColDef[] = [
    // {
    //   headerName: 'Type',
    //   field: 'type',
    //   // cellRenderer: (params: any) => {
    //   //   return params?.data?.customer?.customerName;
    //   // },
    // },
    {
      headerName: 'Model',
      field: 'model',
      valueGetter: (params) => {
        if (params?.data?.product?.model && params?.data?.product?.make) {
          return params?.data?.product?.model + '-' + params?.data?.product?.make;
        } else if (params?.data?.product?.make == null || params?.data?.product?.make == "") {
          return params?.data?.product?.model;
        } else {
          return ('NA');
        }
      },
    },
    {
      headerName: 'Location',
      field: 'locationName',
      valueGetter: (params) => {
        // if(params.data?.locationName == "0" || params.data?.locationName == null || !isNaN(parseInt(params.data?.locationName, 10))){
        if (Number.isInteger(parseFloat(params.data?.locationName))) {
          return ''
        } else {
          return params.data?.locationName
        }
      }
    },
    {
      headerName: 'Peripheral Id',
      field: 'peripheralId',
      // valueGetter: (params) => params.data?.peripheralId || 'N/A'
      valueGetter: (params) => {
        if (params.data?.peripheralId == undefined) {
          return '';
        } else if (params.data?.peripheralId == null || params.data?.peripheralId == "") {
          return 'N/A'
        } else {
          return params.data?.peripheralId
        }
      }
    },


    {
      headerName: 'MAC Address',
      field: 'macAddress',
      valueGetter: (params) => {
        if (params.data?.macAddress == undefined) {
          return '';
        } else if (params.data?.macAddress == null || params.data?.macAddress == "") {
          return 'N/A'
        } else {
          return params.data?.macAddress
        }
      }
    },
    {
      headerName: 'Last Changed (UTC)',
      field: 'updatedOn',
      sortable: true,
      valueGetter: (params) => params.data?.updatedOn ?? null,
      cellRenderer: (params: any) => formatUtcDateTimeCell(params?.data?.updatedOn),
    },
    /*******US#2074 reverted*********/
    {
      headerName: 'Actions',
      field: 'actions',
      width: 100,
      sortable: false,
      cellRenderer: ButtonCellRendererComponent,
      cellRendererParams: {
        onDelete: (data: any) => {
          this.onDeletePeripheral(data);
        },
      }
    },
  ];

  /* Start Copy Data cell Value function   */
  contextMenu: { visible: boolean; x: number; y: number; value: any } = {
    visible: false,
    x: 0,
    y: 0,
    value: ''
  };
  selectedCellValue: string = '';
  contextMenuVisible: boolean = false;
  contextMenuPosition = { x: 0, y: 0 };

  getNestedProperty(obj: any, path: string): any {
    return get(obj, path, 'N/A'); // 'N/A' if value is undefined
  }


  onCellContextMenu(event: any) {
    event.event.preventDefault(); // Prevent the browser's default context menu

    let cellValue;
    const columnField = event.colDef.field;

    // If the column has a valueGetter, call it manually
    if (event.colDef.valueGetter) {
      cellValue = event.colDef.valueGetter({ data: event.data });
      console.log('cellValue from valueGetter:', cellValue);
    } else {
      // Use lodash's get method for nested properties
      cellValue = this.getNestedProperty(event.data, columnField);
      console.log('cellValue from field:', cellValue);
    }

    // Set context menu visibility and position
    this.contextMenu = {
      visible: true,
      x: event.event.clientX,
      y: event.event.clientY,
      value: cellValue || 'N/A',
    };
  }


  copyToClipboard(value: string) {
    navigator.clipboard.writeText(value).then(() => {
      console.log('Copied to clipboard:', value);
      this.contextMenu.visible = false;  // Hide context menu after copying
    }).catch(err => {
      console.error('Failed to copy:', err);
    });
  }


  // Hide context menu on outside click
  @HostListener('document:click')
  onDocumentClick(): void {
    this.contextMenu.visible = false;
  }
  preventDefaultContextMenu(event: MouseEvent): void {
    event.preventDefault();
  }
  /* End Copy Data cell Value function   */


  peripheralsSearchPayload = {
    page: 0,
    size: 25,
    filters: [
      {
        field: 'device.id',
        operator: 'eq',
        value: '',
      },
    ],
    sorts: [
      {
        field: 'id',
        direction: 'asc',
      },
    ],
  };
  sortForAgGrid(sortModel: any) {
    if (
      sortModel[0] == undefined ||
      sortModel[0] == null ||
      sortModel[0].colId == undefined ||
      sortModel[0].colId == null
    ) {
      return;
    }
    this.sortFlag = true;
    switch (sortModel[0].colId) {
      case 'locationName': {
        this.peripheralsSearchPayload.sorts[0].field = 'locationName';
        this.peripheralsSearchPayload.sorts[0].direction = sortModel[0].sort;
        break;
      }
      case 'model': {
        this.peripheralsSearchPayload.sorts[0].field = 'product.model';
        this.peripheralsSearchPayload.sorts[0].direction = sortModel[0].sort;
        break;
      }
      case 'macAddress': {
        this.peripheralsSearchPayload.sorts[0].field = 'macAddress';
        this.peripheralsSearchPayload.sorts[0].direction = sortModel[0].sort;
        break;
      }
      case 'peripheralId': {
        this.peripheralsSearchPayload.sorts[0].field = 'peripheralId';
        this.peripheralsSearchPayload.sorts[0].direction = sortModel[0].sort;
        break;
      }
      case 'updatedAt': {
        this.peripheralsSearchPayload.sorts[0].field = 'updatedAt';
        this.peripheralsSearchPayload.sorts[0].direction = sortModel[0].sort;
        break;
      }
      default: {
      }
    }
  }

  onGridReady(params: GridReadyEvent) {
    this.deviceId = localStorage.getItem('deviceId');
    this.gridApi = params;

    const dataSource = {
      getRows: (params: any) => {
        this.sortForAgGrid(params.sortModel);
        this.gridApi.api.setFilterModel(
          (this.peripheralsSearchPayload.filters[0] = {
            field: 'device.id',
            operator: 'eq',
            value: this.deviceId,
          })
        );
        this.peripheralsService
          .getPeripheralsDetails(this.peripheralsSearchPayload)
          .subscribe({
            next: (data: any) => {
              if (data.data) {
                this.rowData = data?.data?.content;
                console.log('peripherals data :', this.rowData);
                this.periIds = this.rowData.map((obj: any) => {
                  return obj.id;
                })
                console.log(this.periIds)
                this.peripheralsService.peripheralIds.next(this.periIds)
                this.loaded.emit();
                this.totalElements = data?.data?.totalElements;
                console.log('totalElements :', this.totalElements);
                params.successCallback(this.rowData, this.totalElements);
              }
            },
            error: (error) => {
              console.error('API Error:', error);
              params.failCallback();
            },
          });
      },
    };
    this.gridApi.api.setGridOption('datasource', dataSource);
  }

  onDeletePeripheral(row: any) {
    const dialogRef = this.dialog.open(ConfirmDeletePeripheralComponent, {
      width: '560px',
      disableClose: true,
      data: row
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'delete') {
        const id = row?.id;
        this.peripheralsService.deletePeripheral(id).subscribe({
          next: () => {
            this.toastr.success('Peripheral deleted successfully');
            if (this.gridApi) {
              this.gridApi.api.paginationGoToFirstPage();
              this.gridApi.api.refreshInfiniteCache();
            }
          },
          error: (error) => {
            const msg = error?.error?.message || 'Failed to delete peripheral';
            this.toastr.error(msg);
          }
        });
      }
    });
  }

  // onGridReady(params: GridReadyEvent) {
  //   this.gridApi = params;
  //   console.log("params ",params)
  //   const dataSource = {
  //     getRows: (params: any) => {
  //       this.sortForAgGrid(params.sortModel);
  //       // this.filterForAgGrid(params.filterModel);

  //       this.deviceService.getAllDevices(this.deviceSearchPayload).subscribe({
  //         next: (data) => {
  //           if (data) {
  //             this.rowData = data?.data?.content;
  //             params.successCallback(
  //               data?.data?.content,
  //               data?.data?.totalElements
  //             );
  //           }
  //         },
  //         error: (error) => {
  //           console.error('API Error:', error);
  //           params.failCallback();
  //         },
  //       });
  //     },
  //   };
  //   this.gridApi.api.setGridOption('datasource', dataSource); // Fixed setGridOption syntax
  // }
}
